"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamificationSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var lineChartCard_1 = require("../../charts/lineChartCard");
var compositeChartCard_1 = require("../../charts/compositeChartCard");
var kpiCard_1 = require("../../charts/kpiCard");
var chartColors_1 = require("../../charts/chartColors");
var formatChartData_1 = require("../../../helpers/analytics/formatChartData");
var dashboardGrid_1 = require("../dashboardGrid");
exports.GamificationSection = (0, react_1.memo)(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var data = _a.data, loading = _a.loading, top_rewards = _a.top_rewards, top_rewards_loading = _a.top_rewards_loading;
    var formatDate = formatChartData_1.formatBucketLabel;
    var tierMovementTrend = (function () {
        if (!(data === null || data === void 0 ? void 0 : data.tier_movement_trend))
            return [];
        return data.tier_movement_trend.map(function (point, index) {
            var _a, _b, _c;
            var prev = (_a = data.prev_tier_movement_trend) === null || _a === void 0 ? void 0 : _a[index];
            return {
                date: formatDate(point.date),
                upgrades: point.upgrades,
                downgrades: point.downgrades,
                lateral: point.lateral,
                prev_upgrades: (_b = prev === null || prev === void 0 ? void 0 : prev.upgrades) !== null && _b !== void 0 ? _b : null,
                prev_downgrades: (_c = prev === null || prev === void 0 ? void 0 : prev.downgrades) !== null && _c !== void 0 ? _c : null,
            };
        });
    })();
    var hasPrevTier = !!((_b = data === null || data === void 0 ? void 0 : data.prev_tier_movement_trend) === null || _b === void 0 ? void 0 : _b.length);
    var badgeEarnRateData = (function () {
        if (!(data === null || data === void 0 ? void 0 : data.badge_earn_rate_trend))
            return [];
        return data.badge_earn_rate_trend.map(function (point, index) {
            var _a;
            var prev = (_a = data.prev_badge_earn_rate_trend) === null || _a === void 0 ? void 0 : _a[index];
            return {
                date: formatDate(point.date),
                rate: Math.round(point.rate * 10) / 10,
                prev_rate: prev != null ? Math.round(prev.rate * 10) / 10 : null,
            };
        });
    })();
    var hasPrevBadge = !!((_c = data === null || data === void 0 ? void 0 : data.prev_badge_earn_rate_trend) === null || _c === void 0 ? void 0 : _c.length);
    var redemptionRateData = (function () {
        if (!(data === null || data === void 0 ? void 0 : data.redemption_rate_trend))
            return [];
        return data.redemption_rate_trend.map(function (point, index) {
            var _a;
            var prev = (_a = data.prev_redemption_rate_trend) === null || _a === void 0 ? void 0 : _a[index];
            return {
                date: formatDate(point.date),
                rate: Math.round(point.rate * 10) / 10,
                prev_rate: prev != null ? Math.round(prev.rate * 10) / 10 : null,
            };
        });
    })();
    var hasPrevRedemption = !!((_d = data === null || data === void 0 ? void 0 : data.prev_redemption_rate_trend) === null || _d === void 0 ? void 0 : _d.length);
    var tierMovement = data === null || data === void 0 ? void 0 : data.tier_movement;
    var tierUp = (_e = tierMovement === null || tierMovement === void 0 ? void 0 : tierMovement.upgrades) !== null && _e !== void 0 ? _e : 0;
    var tierDown = (_f = tierMovement === null || tierMovement === void 0 ? void 0 : tierMovement.downgrades) !== null && _f !== void 0 ? _f : 0;
    var tierLateral = (_g = tierMovement === null || tierMovement === void 0 ? void 0 : tierMovement.lateral) !== null && _g !== void 0 ? _g : 0;
    var tierNet = tierUp - tierDown;
    var tierNetColor = tierNet > 0 ? "text-success" : tierNet < 0 ? "text-danger" : "text-foreground";
    var tierNetDisplay = tierNet > 0 ? "+".concat(tierNet) : tierNet.toString();
    var kpiWidgets = [
        {
            i: "tier_net",
            label: "Net Tier Movement",
            value: tierNetDisplay,
            subtitle: "".concat(tierUp, " up \u00B7 ").concat(tierDown, " down \u00B7 ").concat(tierLateral, " lateral"),
            color: tierNetColor,
            tooltip: "Upgrades minus downgrades from TIER_PROGRESSION events in the period. Positive = tier growth, negative = churn.",
        },
        {
            i: "badge",
            label: "Badge Earn Rate",
            value: (0, formatChartData_1.formatPercentage)(data === null || data === void 0 ? void 0 : data.badge_earn_rate),
            subtitle: "of active users this period",
            color: "text-foreground",
            tooltip: "Share of active users who earned at least one badge in the period. Denominator is active users, not total members.",
        },
    ];
    var widgets = __spreadArray(__spreadArray([], kpiWidgets.map(function (widget, idx) { return ({
        i: widget.i,
        x: idx * 6,
        y: 0,
        w: 6,
        h: 2,
        hideTitle: true,
        noShell: true,
        content: (0, jsx_runtime_1.jsx)(kpiCard_1.KPICard, { title: widget.label, value: widget.value, subtitle: widget.subtitle, valueColor: widget.color, tooltip: widget.tooltip }),
    }); }), true), [
        {
            i: "tier_movement",
            x: 0,
            y: 2,
            w: 6,
            h: 4,
            title: "Tier Movement Over Time",
            tooltip: "Per-day count of tier upgrades, downgrades, and lateral moves from TIER_PROGRESSION events.",
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Tier Movement Over Time", data: tierMovementTrend, lineKeys: __spreadArray([
                    { key: "upgrades", name: "Upgrades", color: chartColors_1.chartColors.success.base },
                    { key: "downgrades", name: "Downgrades", color: chartColors_1.chartColors.danger.base }
                ], (hasPrevTier
                    ? [
                        { key: "prev_upgrades", name: "Upgrades (prev)", color: chartColors_1.chartColors.success.faded, dashed: true },
                        { key: "prev_downgrades", name: "Downgrades (prev)", color: chartColors_1.chartColors.danger.faded, dashed: true },
                    ]
                    : []), true), barKeys: [
                    { key: "lateral", name: "Lateral", color: chartColors_1.chartColors.muted.faded },
                ], xAxisKey: "date", noCard: true, loading: loading })),
        },
        {
            i: "badge_trend",
            x: 6,
            y: 2,
            w: 6,
            h: 4,
            title: "Badge Earn Rate Trend",
            tooltip: "Per-day share of active users who earned a badge.",
            content: ((0, jsx_runtime_1.jsx)(lineChartCard_1.LineChartCard, { title: "Badge Earn Rate Trend", data: badgeEarnRateData, dataKeys: __spreadArray([
                    {
                        key: "rate",
                        name: "Earn Rate (%)",
                        color: chartColors_1.chartColors.secondary.base,
                    }
                ], (hasPrevBadge
                    ? [
                        {
                            key: "prev_rate",
                            name: "Earn Rate (prev)",
                            color: chartColors_1.chartColors.secondary.faded,
                            dashed: true,
                        },
                    ]
                    : []), true), xAxisKey: "date", noCard: true, loading: loading })),
        },
        {
            i: "redemption_trend",
            x: 0,
            y: 6,
            w: 12,
            h: 4,
            title: "Milestone Rate Trend",
            tooltip: "Per-day share of active users who hit at least one reward-track milestone.",
            content: ((0, jsx_runtime_1.jsx)(lineChartCard_1.LineChartCard, { title: "Milestone Rate Trend", data: redemptionRateData, dataKeys: __spreadArray([
                    {
                        key: "rate",
                        name: "Milestone Rate (%)",
                        color: chartColors_1.chartColors.warning.base,
                    }
                ], (hasPrevRedemption
                    ? [
                        {
                            key: "prev_rate",
                            name: "Milestone Rate (prev)",
                            color: chartColors_1.chartColors.warning.faded,
                            dashed: true,
                        },
                    ]
                    : []), true), xAxisKey: "date", noCard: true, loading: loading })),
        },
        {
            i: "top_rewards",
            x: 0,
            y: 10,
            w: 12,
            h: 4,
            title: "Top Milestone Rewards",
            tooltip: "Most-frequently granted milestone rewards in the period, by grant count and unique players reached.",
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Top Milestone Rewards", data: (_j = (_h = top_rewards === null || top_rewards === void 0 ? void 0 : top_rewards.items) === null || _h === void 0 ? void 0 : _h.map(function (reward) { return ({
                    name: reward.reward.length > 32 ? "".concat(reward.reward.slice(0, 32), "\u2026") : reward.reward,
                    grants: reward.grant_count,
                    unique_players: reward.unique_players,
                }); })) !== null && _j !== void 0 ? _j : [], barKeys: [
                    { key: "grants", name: "Grants", color: chartColors_1.chartColors.secondary.base },
                    { key: "unique_players", name: "Unique Players", color: chartColors_1.chartColors.success.base },
                ], xAxisKey: "name", layout: "vertical", noCard: true, loading: top_rewards_loading })),
        },
    ], false);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-bold text-foreground", children: "Gamification Metrics" }), (0, jsx_runtime_1.jsx)(dashboardGrid_1.DashboardGrid, { widgets: widgets })] }));
});
exports.GamificationSection.displayName = "GamificationSection";
